import React from "react";
import "./crimsonOak.scss";
import ImageZoom from "components/imageZoom/ImageZoom";
import crimsonOakCover from "assets/img/home/crimsonOak/crimsonOakCover.webp";
import crimsonOak1 from "assets/img/home/crimsonOak/crimsonOak1.webp";
import crimsonOak2 from "assets/img/home/crimsonOak/crimsonOak2.webp";
import crimsonOak3 from "assets/img/home/crimsonOak/crimsonOak3.webp";
import { Link, useNavigate } from "react-router-dom";
import { CRIMSON_OAK_ID } from "constant";
import { LoadingButton } from "@mui/lab";
import productStore from "store/productStore";
import cartStore from "store/cartStore";
import { useEffect, useState } from "react";
import ReactPixel from "react-facebook-pixel";
import { ENV } from "constant";
import authStore from "store/authStore";
import ImageSlider from "../imageSlider/ImageSlider";
import imageLoadStore from "store/imageLoadStore";

const CrimsonOak = () => {
  const ImageLoadStore = imageLoadStore();
  const navigate = useNavigate();

  const ProductStore = productStore();
  const AuthStore = authStore();
  const CartStore = cartStore();
  const [product, setProduct] = useState(null);
  const [isAddToCartLoading, setIsAddToCartLoading] = useState(false);
  const [isAddToCart, setIsAddToCart] = useState(false);

  useEffect(() => {
    fetchSpecificProductRating();
  }, []);

  const fetchSpecificProductRating = async () => {
    const product = await ProductStore.fetchOneProduct({
      _id: CRIMSON_OAK_ID,
    });
    setProduct(product);
  };

  useEffect(() => {
    if (CartStore.cartProduct && product) {
      setIsAddToCart(false);
      const isCart = CartStore.cartProduct.find(
        (item) => item.productID === product._id,
      );
      if (isCart) {
        setIsAddToCart(true);
      }
    }
  }, [CartStore.cartProduct && CartStore.cartProduct.length, product]);

  const AddToCart = async () => {
    if (AuthStore.isLogged) {
      setIsAddToCartLoading(true);
      await CartStore.signInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
      setIsAddToCartLoading(false);
    } else {
      await CartStore.noSignInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
    }

    if (ENV === "production") {
      ReactPixel.track("AddToCart", {
        content_ids: [product._id],
        content_name: product.productName,
        value: product.salePrice ? product.salePrice : product.regularPrice,
        currency: "INR",
      });
    }
    navigate("/checkout");
  };

  return (
    <div className="crimson-oak-home">
      <div className="first-container">
        <div className="image-container">
          <img src={crimsonOakCover} alt="crimson-oak-perfume-background" />
        </div>

        <div className="text-container">
          <div className="text-wrapper">
            <h2>Crimson Oak</h2>
            <div className="quote-container">
              <q>Grounded in Earthy Elegance.</q>
              <p>
                Crimson Oak invites you to reconnect with the truth of nature. A
                rich, woody composition that balances the deep strength of oak
                with crimson warmth, creating a scent that is both mysterious
                and comforting.
              </p>
            </div>
            <div className="button-container">
              <Link
                to={`/perfume/crimson-oak/${CRIMSON_OAK_ID}/details`}
                className="link learn-more-link"
                onClick={() => {
                  ImageLoadStore.setImageLoading(true);
                }}
              >
                Learn More
              </Link>
              <LoadingButton
                loading={isAddToCartLoading}
                onClick={
                  isAddToCart
                    ? () => {
                        navigate("/checkout");
                      }
                    : AddToCart
                }
                className="btn btn-buy-now"
              >
                Buy Now
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
      <div className="second-container">
        <div className="left-container">
          <div className="image-container">
            <div className="left-move-container">
              <div className="left-first-image img-content">
                <ImageZoom src={crimsonOak1} alt="crimson-oak-first-left" />
              </div>
            </div>
            <div className="left-second-image img-content">
              <ImageZoom src={crimsonOak2} alt="crimson-oak-second-left" />
            </div>
          </div>
        </div>
        <div className="right-container">
          <div className="image-container">
            <div className="right-image img-content">
              <ImageZoom src={crimsonOak3} alt="crimson-oak-right" />
            </div>
          </div>
          <div className="quote-content">
            <q>Woody niche perfume, earthy fragrances, premium oak scent.</q>
          </div>
        </div>
      </div>
      <ImageSlider
        alt="crimson-oak"
        images={[crimsonOak1, crimsonOak2, crimsonOak3]}
        quoteText={"Woody niche perfume, earthy fragrances, premium oak scent."}
      />
    </div>
  );
};

export default CrimsonOak;
